import { GlobalContext } from "components/GlobalContext";
import { useContext, useRef } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";

const ReportsLookup = () => {
    const globalContext = useContext(GlobalContext);
    const globalContextRef = useRef(globalContext);
    globalContextRef.current = globalContext;

    return (
        <>
            <Row>
                {
                    globalContext.roles.some(r => r === "Web.QRCodeGenerator") &&
                    <Col>
                        <Card data-color-mode="light">
                            <Card.Body>
                                <LinkContainer to="/Reports/Opportunities" style={{ width: "100%" }}>
                                    <Button variant="primary" size="lg" className="mr-1">
                                        Opportunities Report
                                    </Button>
                                </LinkContainer><br />
                                <p className="pt-2">
                                    Information on all opportunities seperated by domestic and international in a date range.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                }
                {
                    globalContext.roles.some(r => r === "Web.HealthRiskAssessments") &&
                    <Col>
                        <Card data-color-mode="light">
                            <Card.Body>
                                <LinkContainer to="/Reports/HRAOverviewReport" style={{ width: "100%" }}>
                                    <Button variant="primary" size="lg" className="mr-1">
                                        HRA Overview Report
                                    </Button>
                                </LinkContainer><br />
                                <p className="pt-2">
                                    Information on all HRA's in a date range.
                                </p>
                            </Card.Body>
                        </Card>
                    </Col>
                }
            </Row>
        </>
    );
}

export default ReportsLookup;
